/**
 * list item view
 */
import type { HoursOfOperation } from '@m/types/api/Site';
import type { LicensePlate } from '@m/types/api/Vehicle';
import type { IdNameObject } from '@m/types/index';

export enum ViolationTypeName {
  Vision = 'Vision',
  NoVisitStarted = 'No_Visit_Started',
  ExpiredTime = 'Expired_Time',
}

export interface ViolationType {
  description: string;
  id: number;
  name: ViolationTypeName;
}

export interface ViolationItem {
  extId: string;
  /** dollar format 50.5 == $50.50 */
  fineAmount: number;

  id: number;
  licensePlate: LicensePlate;
  parkingAmount: number;
  processingFeeAmount: number;

  siteName: string;

  totalAmount: number;

  /** timestamp */
  violationIssued: number;

  violationStatus: IdNameObject;
}

export type ViolationEventDetailsView = {
  eventTime: number;
  licensePlateImageContext: string;
  licensePlateImagePlate: string;
};

export interface ViolationDetails extends ViolationItem {
  availableActions: IdNameObject[]; // todo: get specific actions
  datePaid: number | null;
  entryView: ViolationEventDetailsView;
  exitView: ViolationEventDetailsView;
  isMember?: boolean | null;

  originalFineAmount?: number | null;
  sentNotice1: number | null;
  sentNotice2: number | null;

  site: {
    city: string;
    hoursOfOperation: HoursOfOperation;
    id: number;
    internalName: string;
    latitude: number;
    longitude: number;
    name: string;
    state: string;
    street: string;
    zip: string;
  };

  siteTimeZone: string | null;

  skiptrace: Skiptrace | null;

  violationType: ViolationType;
}

export interface Skiptrace {
  address: string;
  city: string;
  // all fields can be empty string
  firstName: string;
  lastName: string;
  state: string;
  zipcode: string;
}

export interface ViolationPlan {
  effectiveDate: string; // DATE_FORMAT_ISO_8601 yyyy-mm-dd
  fineAmount: number;
  id: number;
  isPaused: boolean;
}
